/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { getDialogInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { ColDef } from 'ag-grid-community';
import { cloneDeep } from 'lodash';

@Injectable()
export class GenericFinderGridDefinition extends AbstractFinderGridDefinition {
  getId: TransformFn<any, ID>;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any) {
    super();

    const { getId } = getDialogInitData(this.dialogData);

    this.getId = getId;
  }

  buildColumnDefs(): ColDef[] {
    return cloneDeep(getDialogInitData(this.dialogData)['columnDefs']);
  }
}
